<template>
  <div class="select-price-card popup-full">
    <div class="popup-full__wrap">
      <div class="popup-full__content">
        <h1 class="edit-additional-questions-card__title mt-0 mb-0">{{ $tAccountSubscription('top_up_balance') }}</h1>

        <div class="select-price-card__inner-block relative mt-4">
          <div class="select-price-card__inner-block-title">
            {{ $tAccountSubscription('specify_amount') }}
          </div>

          <div class="select-price-card__price-buttons mt-5">
            <button
              v-for="(priceValue, index) in priceButtons"
              :key="index"
              class="base-btn base-btn--small base-btn--outline-dark select-price-card__price-button"
              :class="{ _active: price === Number(priceValue) }"
              @click="price = Number(priceValue)"
            >
              {{ selectedCurrency }} {{ priceValue }}
            </button>
          </div>

          <div class="mb-1 mt-5">{{ $tAccountSubscription('another_amount') }}</div>
          <div class="relative d-flex items-center">
            <div class="select-price-card__inner-block-currency">{{ selectedCurrency }}</div>
            <BaseInput
              v-model.number="price"
              type="number"
              autofocus
              :mask="priceMask"
              class="select-price-card__inner-block-field full-width"
            />
          </div>
        </div>

        <div class="select-price-card__actions mt-4">
          <button
            class="select-price-card__action-btn base-btn base-btn--blue"
            :disabled="!price"
            @click="submit"
          >
            <span>{{ $tAccountSubscription('pay') }}</span>
            <span v-if="price" class="ml-1">{{ `${selectedCurrency} ` + price }}</span>
          </button>

          <div class="select-price-card__actions-images">
            <div>
              <img :src="require('../../assets/img/select-price-card/revolut.png')" alt="">
            </div>
            <div class="select-price-card__actions-images-divider"></div>
            <div>
              <img :src="require('../../assets/img/select-price-card/mastercard-visa.png')" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNumberMask } from 'text-mask-addons';

const priceMask = createNumberMask({
  includeThousandsSeparator: true,
  thousandsSeparatorSymbol: '',
  allowNegative: false,
  integerLimit: 15,
  allowDecimal: true,
  prefix: '',
});

export default {
  name: 'SelectPriceCard',
  props: {
    modalName: {
      type: String,
      default: '',
    },
    onSubmit: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      selectedCurrency: '€',
      price: 0,
      priceMask,
    };
  },
  computed: {
    priceButtons() {
      return [
        '10',
        '25',
        '50',
        '100',
      ];
    },
  },
  methods: {
    submit() {
      this.onSubmit({ price: this.price });
      this.$vModal.close(this.modalName);
    },
  },
};
</script>
